import React, { useEffect } from "react";

const packageVersion = require("../../../package.json").version;
const BUILD_ID = process.env.REACT_APP_BUILD_ID || "dev";

const VersionControl = () => {
  useEffect(() => {
    try {
      window.localStorage.setItem("version", packageVersion);
      if (BUILD_ID) {
        window.localStorage.setItem("buildId", BUILD_ID);
      }
    } catch (_) {}
  }, []);

  return null;
};

export default VersionControl;
